import React from 'react';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
export function DescriptionFaqSkeleton() {
    const { isMobileView } = useWindowSize();
    return (React.createElement(Container, null,
        React.createElement(Row, { mt: "24px", mdMt: "24px", lgMt: "48px" },
            React.createElement(Col, { lg: 12, md: 8 },
                React.createElement(Skeleton, { skeletonProps: {
                        height: isMobileView ? 250 : 280,
                    } })))));
}
